import { render } from "./eventShow.vue?vue&type=template&id=567186de&scoped=true"
import script from "./eventShow.vue?vue&type=script&lang=js"
export * from "./eventShow.vue?vue&type=script&lang=js"

import "./eventShow.vue?vue&type=style&index=0&id=567186de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567186de"]])

export default __exports__